import { FaBars } from "react-icons/fa";
import { NavLink as Link } from "react-router-dom";
//import styled from "styled-components";
import styled, { keyframes } from "styled-components";
import '../App.css';
import './navbar2.css';

export const Nav = styled.nav`
background: transparent;
position: fixed;
/*border: 3px solid rgb(151, 5, 19);*/
height: 25vh;
display: flex;
/*justify-content: space-between;*/
/*justify-content: center;*/
/*padding: 0.2rem calc((100vw - 90rem) / 2);*/
z-index: 1020;
width: 100%;
transition: transform 0.3s ease-in-out; 
transform: translateY(0); 
/*box-shadow: 5px 10px 20px rgba(178, 173, 173, 0.5);*/

&.visible {
    transform: translateY(-25vh); 
  }

@media screen and (max-width: 1440px) {
	/*padding: 0.2rem calc((100vw - 70rem) / 2);*/
}

@media screen and (max-width: 1080px) {
	/*padding: 0.2rem calc((100vw - 60rem) / 2);*/
  /*display: none;*/
}

  @media screen and (max-width: 1080px) {
  display: none;
  box-shadow: none;
  &.active {
    display: block;
    animation: slideInFrombottom 0.5s ease-in forwards;
  }

  @keyframes slideInFrombottom {
    0% {
	 opacity: 0;
	transform: translateY(100%);
  }
	50% {
	opacity: 0.5;
	transform: translateY(0);
  }
	100% {
	opacity: 1;
	transform: translateY(0);
  }
 }
  }
}	

`;

const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const NavLink = styled(Link)`
color: white;
display: flex;
align-items: center;
text-decoration: none;
position: relative;
padding: 0 2rem;
font-size: 1rem;
font-family: Arial, Helvetica, sans-serif;
/*border: 3px solid rgb(81, 187, 24);*/
/*height: 100%;*/
height: fit-content;
cursor: pointer;
z-index: 1050;
&.active {
	color: rgb(51, 159, 15);
}

@media screen and (max-width: 956px) {
  height: -webkit-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  padding: 0 0rem;
  width: fit-content;
  flex-grow: .08; 
  justify-content: center; 
  /*margin: 0 auto; */
  animation: slideInFrombottom 0.5s ease-in forwards;
  animation-delay: 0.5s;
  opacity: 0;
  
}

@keyframes slideInFrombottom {
    0% {
	 opacity: 0;
	transform: translateY(100%);
  }
	50% {
	opacity: 0.5;
	transform: translateY(0);
  }
	100% {
	opacity: 1;
	transform: translateY(0);
  }
 }

@media screen and (max-width: 440px) {
  flex-grow: .08;
  
}

&:hover {
	color: rgb(127, 236, 117);
	.dropdown-content {
      display: block;
      animation: ${fadeInDown} 0.3s ease-in-out forwards; 
    }
  }

  .dropdown-content {
    display: none;
    position: absolute;
    top: 55%;
    left: 0;
    /*background-color: grey;*/
	  background-image: linear-gradient(to top right, rgb(134, 236, 134), rgb(190, 232, 190), rgba(255, 255, 255));
    min-width: 240px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1051;
    opacity: 0;
    transform: translateY(-10px);
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    animation: none; /* Avoid conflicts with hover animation */
    /*border: 3px solid rgb(151, 3, 3);*/
    border-radius: 20px;
	

	&.toggled {
	 	  top: 30%;
    	left: 0%;

		@media screen and (max-width: 956px) and (orientation: landscape) {
		  top: -120%;
	 	  left: -90%;
      min-width: 240px;
      padding-left: 30%;
	}
    @media screen and (max-width: 440px) {
		  top: 40%;
	 	  left: -55%;
      min-width: 230px;
      padding-left: 30%;
	  }
	}
	
	a {
      margin-left:-.5%;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
      /*border: 3px solid rgb(151, 3, 3);*/
      font-size: 1.5rem;
    }
	  
  }
    

  &.toggled {
    padding: 0 0rem;
    padding-top: .5%;
    padding-bottom: .5%;
    margin: 1%;
	  height: fit-content;
    top: -8%;
    

    @media screen and (max-width: 956px) and (orientation: landscape) {
        margin: .5%;
        top: 1%;
        padding-top: 1%;
        padding-bottom: 1%;
        
	  }

    @media screen and (max-width: 440px) {
      display: inline;
      height: fit-content;
      padding: 0 0rem;
      /*border: 3px solid rgb(151, 3, 3);*/
      margin: 0%;
      padding-top: 5%;
      padding-bottom: 5%;
    }
  }
    
}
`;

export const Bars = styled(FaBars)`
display: none;
color: #808080;
@media screen and (max-width: 768px) {
	display: block;
	position: absolute;
	top: 0;
	right: 0;
	transform: translate(-100%, 75%);
	font-size: 1.8rem;
	cursor: pointer;
}
`;

export const NavMenu = styled.div`
display: flex;
align-items: center;
justify-content: center;
position: relative;
/*border: 3px solid rgb(81, 187, 24);*/
width: 100%;
height: fit-content;
padding-top: 3%;
padding-bottom: 3%;
z-index: 1015;
top: 5%;
/*margin-right: 18vw;*/
/* Second Nav */
/* margin-right: 24px; */
/* Third Nav */
/* width: 100vw;
white-space: nowrap; */



@media screen and (max-width: 1080px) {
	display: none;
	/*padding: 0%;*/
	position: absolute;
  display: flex;
	flex-direction: column;
	justify-content: center;
	background-color: black;
	animation: slideInFrombottom 0.5s ease-in forwards;
	width: 100%; 
	/*height: 100vh;*/
  height: fit-content;
  padding-top: 10%;
  padding-bottom: 5%;
	top: 40%; 
	left: 0;
  
  
  @media screen and (max-width: 956px) {
    top: 10%; 
    padding-top: 5%;
    
  }

  @keyframes slideInFrombottom {
    0% {
	 opacity: 0;
	transform: translateY(100%);
  }
	50% {
	opacity: 0.5;
	transform: translateY(0);
  }
	100% {
	opacity: 1;
	transform: translateY(0);
  }
 }



}
`;
